export default __webpack_public_path__ + "static/media/select-cat.59b53f1c.png";